// CadastroFornecedor.js
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import * as S from './styles';
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import CabecarioIcon from '../../../components/CabecarioIcon';
import { Tabs, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import ViaCepService from '../../../services/Viacep/ViaCepService';
import FornecedorService from '../../../services/Fornecedor/FornecedorService';

import { MascaraCpfCnpj, ValidaCnpj, MascaraCep, MascaraTelefone } from '../../../utils/mask';
import secureStorage from '../../../utils/SecureStorage';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';

const CadastroFornecedor = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [erro, setErro] = useState('');
  const [fornecedor, setFornecedor] = useState({
    id: '',
    id_rede: secureStorage.getItem("id_r"),
    razao_social: '',
    nome_fantasia: '',
    tipo_documento: 'CNPJ',
    documento: '',
    inscricao_estadual: '',
    inscricao_municipal: '',
    ramo_atividade: '',
    contato: {
      telefone: '',
      celular: '',
      email: '',
      WhatsApp: '',
      pessoa_contato: '',
      observacoes: ''
    },
    endereco: {
      rua: '', numero: '', complemento: '', bairro: '', cep: '', cidade: '', estado: ''
    },
    dados_bancarios: {
      banco: '', agencia: '', conta: '', tipo_conta: ''
    }
  });

  const handleChange = (e) => {
    let { name, value } = e.target;

    switch (name) {
      case 'documento':
        value = MascaraCpfCnpj(value);
        break;
      case 'endereco.cep':
        value = MascaraCep(value);
        break;
      case 'contato.telefone':
      case 'contato.celular':
      case 'contato.WhatsApp':
        value = MascaraTelefone(value);
        break;
      default:
        break;
    }

    if (name.includes('.')) {
      const [parentKey, childKey] = name.split('.');
      setFornecedor(prev => ({
        ...prev,
        [parentKey]: {
          ...prev[parentKey],
          [childKey]: value
        }
      }));
    } else {
      setFornecedor(prev => ({ ...prev, [name]: value }));
    }
  };

  const onBlurCep = async (e) => {
    const cep = e.target.value.replace(/\D/g, '');
    if (cep.length !== 8) return;
    try {
      const data = await ViaCepService.fetchAddress(cep);
      if (!data.erro) {
        setFornecedor(prev => ({
          ...prev,
          endereco: {
            ...prev.endereco,
            rua: data.logradouro,
            bairro: data.bairro,
            cidade: data.localidade,
            estado: data.uf,
            cep: e.target.value
          }
        }));
      } else alert('CEP não encontrado.');
    } catch (error) {
      alert('Erro ao buscar CEP');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cnpj = fornecedor.documento.replace(/\D/g, '');
    if (!ValidaCnpj(cnpj)) {
      setErro('CNPJ inválido');
      return;
    }
    if (!fornecedor.razao_social) {
      alert('Informe a Razão Social do fornecedor');
      return;
    }
    try {
      await FornecedorService.saveFornecedor(fornecedor);
      handleResetForm();
      setTabIndex(0);
    } catch (error) {
      console.error(error);
      setErro('Erro ao salvar');
    }
  };

  const handleResetForm = () => {
    setFornecedor({
      id: '',
      id_rede: secureStorage.getItem("id_r"),
      razao_social: '',
      nome_fantasia: '',
      tipo_documento: 'CNPJ',
      documento: '',
      inscricao_estadual: '',
      inscricao_municipal: '',
      ramo_atividade: '',
      contato: {
        telefone: '', celular: '', email: '', WhatsApp: '', pessoa_contato: '', observacoes: ''
      },
      endereco: {
        rua: '', numero: '', complemento: '', bairro: '', cep: '', cidade: '', estado: ''
      },
      dados_bancarios: {
        banco: '', agencia: '', conta: '', tipo_conta: ''
      }
    });
  };

  return (
    <>
      <Header />
      <S.BackButton onClick={() => navigate('/home')}>
        <MdArrowBack style={{ marginRight: '8px', fontSize: '20px' }} /> Voltar
      </S.BackButton>
      <S.Container>
        <S.Form onSubmit={handleSubmit}>
          <S.Title>Cadastro de Fornecedor</S.Title>
          <CabecarioIcon title="Cadastro de Fornecedor" />
          <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
            <S.StyledTabList>
              <S.StyledTab>Dados Gerais</S.StyledTab>
              <S.StyledTab>Endereço</S.StyledTab>
              <S.StyledTab>Contato</S.StyledTab>
              <S.StyledTab>Dados Bancários</S.StyledTab>
            </S.StyledTabList>

            <TabPanel>
              <S.InputGroup>
                <S.Label>Razão Social:</S.Label>
                <S.Input name="razao_social" value={fornecedor.razao_social} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Nome Fantasia:</S.Label>
                <S.Input name="nome_fantasia" value={fornecedor.nome_fantasia} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>CNPJ:</S.Label>
                <S.Input name="documento" value={fornecedor.documento} onChange={handleChange} maxLength={18} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Inscrição Estadual:</S.Label>
                <S.Input name="inscricao_estadual" value={fornecedor.inscricao_estadual} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Inscrição Municipal:</S.Label>
                <S.Input name="inscricao_municipal" value={fornecedor.inscricao_municipal} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Ramo de Atividade:</S.Label>
                <S.Input name="ramo_atividade" value={fornecedor.ramo_atividade} onChange={handleChange} />
              </S.InputGroup>
            </TabPanel>

            <TabPanel>
              <S.InputGroup>
                <S.Label>CEP:</S.Label>
                <S.Input name="endereco.cep" value={fornecedor.endereco.cep} onChange={handleChange} onBlur={onBlurCep} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Rua:</S.Label>
                <S.Input name="endereco.rua" value={fornecedor.endereco.rua} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Número:</S.Label>
                <S.Input name="endereco.numero" value={fornecedor.endereco.numero} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Complemento:</S.Label>
                <S.Input name="endereco.complemento" value={fornecedor.endereco.complemento} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Bairro:</S.Label>
                <S.Input name="endereco.bairro" value={fornecedor.endereco.bairro} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Cidade:</S.Label>
                <S.Input name="endereco.cidade" value={fornecedor.endereco.cidade} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Estado:</S.Label>
                <S.Input name="endereco.estado" value={fornecedor.endereco.estado} onChange={handleChange} maxLength={2} />
              </S.InputGroup>
            </TabPanel>

            <TabPanel>
              <S.InputGroup>
                <S.Label>Telefone:</S.Label>
                <S.Input name="contato.telefone" value={fornecedor.contato.telefone} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Celular:</S.Label>
                <S.Input name="contato.celular" value={fornecedor.contato.celular} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>WhatsApp:</S.Label>
                <S.Input name="contato.WhatsApp" value={fornecedor.contato.WhatsApp} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Email:</S.Label>
                <S.Input name="contato.email" value={fornecedor.contato.email} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Pessoa de Contato:</S.Label>
                <S.Input name="contato.pessoa_contato" value={fornecedor.contato.pessoa_contato} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Observações:</S.Label>
                <S.TextArea name="contato.observacoes" value={fornecedor.contato.observacoes} onChange={handleChange} />
              </S.InputGroup>
            </TabPanel>

            <TabPanel>
              <S.InputGroup>
                <S.Label>Banco:</S.Label>
                <S.Input name="dados_bancarios.banco" value={fornecedor.dados_bancarios.banco} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Agência:</S.Label>
                <S.Input name="dados_bancarios.agencia" value={fornecedor.dados_bancarios.agencia} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Conta:</S.Label>
                <S.Input name="dados_bancarios.conta" value={fornecedor.dados_bancarios.conta} onChange={handleChange} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Tipo de Conta:</S.Label>
                <S.Input name="dados_bancarios.tipo_conta" value={fornecedor.dados_bancarios.tipo_conta} onChange={handleChange} />
              </S.InputGroup>
            </TabPanel>

          </Tabs>
          {erro && <S.Erro>{erro}</S.Erro>}
          <S.ButtonGroup>
            <S.Button type="submit">Salvar</S.Button>
            <S.Button type="button" onClick={handleResetForm}>Novo</S.Button>
          </S.ButtonGroup>
        </S.Form>
      </S.Container>
      <Footer />
    </>
  );
};

export default CadastroFornecedor;
